import { Logo } from '@/components/Logo';
import { getDestination } from '@/features/interactions/addToCalendar/destinations/registry';
import type { PlatformTypes } from '@/types/gql.generated';
import { Icon, Image, Text } from '@/ui';

export type Props = {
  platform: PlatformTypes;
  iconStyle?: 'bw' | 'color';
  size?: string | number;
};

// Renders the destination module's declared icon spec; platforms without a
// module (or without an icon) fall back to the 📆 emoji. The image assets live
// in ./icons and are imported by the destination entry files.
export const PlatformIcon = ({
  platform,
  iconStyle = 'color',
  size = '16px',
  ...ui
}: Props) => {
  const sizeValue = typeof size === 'number' ? `${size}px` : size;
  const icon = getDestination(platform)?.icon;

  if (icon?.kind === 'logo') {
    return (
      <Logo
        height={typeof size === 'number' ? size : parseFloat(sizeValue)}
        {...ui}
      />
    );
  }

  if (icon?.kind === 'svgIcon') {
    return <Icon as={icon.component} boxSize={sizeValue} {...ui} />;
  }

  if (icon?.kind === 'image') {
    const src = iconStyle === 'bw' && icon.bwSrc ? icon.bwSrc : icon.src;
    if (icon.fit === 'width') {
      return <Image h="auto" src={src} w={sizeValue} {...ui} />;
    }
    return <Image boxSize={sizeValue} src={src} {...ui} />;
  }

  return (
    <Text
      fontSize={sizeValue}
      left="-1px"
      pos="relative"
      w={sizeValue}
      {...ui}
      lineHeight="1"
    >
      📆
    </Text>
  );
};
